
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { TestDetails } from "@/hooks/test-creator/useTestDetails";
import { SkillsInput } from "./SkillsInput";
import { MapPin, Wallet, Sparkles, Clock, Globe } from "lucide-react";
import { JobCompensation } from "@/components/job/JobCompensation";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { WorkArrangementType } from "@/hooks/test-creator/useTestDetails";

interface JobInfoProps {
  details: TestDetails;
  onChange: (details: TestDetails) => void;
}

export const JobInfo = ({ details, onChange }: JobInfoProps) => {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="keySkills" className="flex items-center gap-2">
          <Sparkles className="h-4 w-4" />
          Key Skills
        </Label>
        <SkillsInput
          skills={details.keySkills}
          onChange={(skills) => onChange({ ...details, keySkills: skills })}
          placeholder="Add a skill..."
          className="bg-card text-card-foreground"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="workArrangement" className="flex items-center gap-2">
            <Globe className="h-4 w-4" />
            Work Arrangement
          </Label>
          <Select
            value={details.workArrangement}
            onValueChange={(value: WorkArrangementType) =>
              onChange({ ...details, workArrangement: value })
            }
          >
            <SelectTrigger className="bg-card text-card-foreground">
              <SelectValue placeholder="Select work arrangement" />
            </SelectTrigger>
            <SelectContent className="bg-card">
              <SelectItem value="Full-Time">Full-Time</SelectItem>
              <SelectItem value="Part-Time">Part-Time</SelectItem>
              <SelectItem value="Freelance">Freelance</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="yearsOfExperience" className="flex items-center gap-2">
            <Clock className="h-4 w-4" />
            Years of Experience
          </Label>
          <Input
            id="yearsOfExperience"
            type="text"
            value={details.yearsOfExperience}
            onChange={(e) => onChange({ ...details, yearsOfExperience: e.target.value })}
            placeholder="e.g. 3-5 years"
            className="bg-card"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="location" className="flex items-center gap-2">
            <MapPin className="h-4 w-4" />
            Location
          </Label>
          <Input
            id="location"
            type="text"
            value={details.location}
            onChange={(e) => onChange({ ...details, location: e.target.value })}
            placeholder="Enter location"
            className="bg-card"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label className="flex items-center gap-2">
          <Wallet className="h-4 w-4" />
          Compensation Range - Yearly
        </Label>
        <JobCompensation
          salaryRangeMin={details.salaryRangeMin?.toString() || ''}
          salaryRangeMax={details.salaryRangeMax?.toString() || ''}
          salaryCurrency={details.salaryCurrency}
          onFieldChange={(field, value) => {
            if (field === 'salaryCurrency') {
              onChange({ ...details, salaryCurrency: value as any });
            } else {
              onChange({
                ...details,
                [field]: value ? parseInt(value) : null
              });
            }
          }}
        />
      </div>
    </div>
  );
};
